import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import AddThumbnailByUrl from './AddThumbnailByUrl';
import ProgressBar from '../../shared/ProgressBar';
import { validateDimensions } from './ImageDimensionValidator';
import { useFileUpload } from './useFileUpload';

const ThumbnailUpload = props => {
  const {
    status,
    filePayload,
    error: uploadError,
    filename,
    uploadFile,
    uploadPercent
  } = useFileUpload('/thumbnails');

  React.useEffect(
    function handleUploadError() {
      if (uploadError) {
        props.handleError(uploadError);
      }
    },
    [uploadError]
  );

  React.useEffect(
    function handleUploadResponse() {
      if (!filePayload) {
        return;
      }

      if (
        filePayload.content_type === 'image/gif' ||
        props.action === 'banner'
      ) {
        // Just skip the whole crop UX state, set the thumbnail as-is
        props.setCroppedThumbnailUrl(filePayload.thumbnail_url);
      } else {
        props.setThumbnailUrl(filePayload.thumbnail_url);
      }
    },
    [filePayload]
  );

  const onDrop = files => {
    const file = files[0];
    props.handleError('');

    if (!file.type.match('image')) {
      props.handleError('Please upload an image');
      return;
    }

    validateDimensions(file, props.action)
      .then(() => {
        uploadFile(file);
      })
      .catch(err => {
        props.handleError(err);
      });
  };

  return (
    <Fragment>
      {status === 'loading' ? (
        <ProgressBar completedPercentage={uploadPercent} filename={filename} />
      ) : (
        <div className="mt4 file-upload">
          <Dropzone
            style={
              /* override Dropzone's default styles */
              {}
            }
            onDrop={onDrop}
          >
            {({getRootProps, getInputProps}) => (
              <div className="null-state-container" data-testid="upload-image" {...getRootProps()}>
                <input {...getInputProps()} />
                <img alt="drag and drop here" src="https://legacy-design-assets.s3.amazonaws.com/images/drag_drop_icon.png" />
                <div className="inline ml2 text-left">
                  <h2>Drag &amp; drop an image</h2>
                  <p className="help-block">
                    or click to upload an image from your computer
                  </p>
                </div>
              </div>
            )}
          </Dropzone>
          <AddThumbnailByUrl setThumbnailUrl={props.setCroppedThumbnailUrl}/>
        </div>
      )}
    </Fragment>
  );
};

ThumbnailUpload.propTypes = {
  setThumbnailUrl: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  setCroppedThumbnailUrl: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired
};

export default ThumbnailUpload;
